
export default function GlossaryResearchVerticalDivider() {
    // Used through the app to display a vertical mini divider
    // to separate two pieces of information

    // BUILD
    return (
        <div className={"select-none w-[1px] h-[24px] min-h-[24px] bg-backgroundLight7"} />
    );
}